import { render, staticRenderFns } from "./contract-data-summarization.vue?vue&type=template&id=fadf3e14&scoped=true&"
import script from "./contract-data-summarization.vue?vue&type=script&lang=js&"
export * from "./contract-data-summarization.vue?vue&type=script&lang=js&"
import style0 from "./contract-data-summarization.vue?vue&type=style&index=0&id=fadf3e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadf3e14",
  null
  
)

export default component.exports